import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { logScreen } from '../utils/analytics';
import { useAppSelector } from '../app/hooks';
import { getMember } from '../libs/polygon-ordering/src/selectors';

const CanaryCurrentScreen: React.FC = () => {
  let location = useLocation();
  const prevLocation = useRef(location);
  const member = useAppSelector(getMember);

  useEffect(() => {
    // Checking the ref will prevent duplicate events
    if (prevLocation.current.pathname !== location.pathname) {
      logScreen({ screen: location.pathname, userId: member?.id });
    }
    prevLocation.current = location;
  }, [location]);

  return null;
};

export default CanaryCurrentScreen;
